module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// ./~/crossfilter/index.js
// module id = 125
// module chunks = 0